
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track-your-order",
      function () {
        return require("private-next-pages/track-your-order/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track-your-order"])
      });
    }
  